/**
 * @generated SignedSource<<94a2e4b89a893c947458d602dad1156f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issuesHeading_versionProgress$data = {
  readonly doneIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly inProgressIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly todoIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "issuesHeading_versionProgress";
};
export type issuesHeading_versionProgress$key = {
  readonly " $data"?: issuesHeading_versionProgress$data;
  readonly " $fragmentSpreads": FragmentRefs<"issuesHeading_versionProgress">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "totalCount"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issuesHeading_versionProgress",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "doneIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "DONE"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "doneIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
      },
      "action": "THROW",
      "path": "doneIssuesRedesignTemp"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "inProgressIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "IN_PROGRESS"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "inProgressIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
      },
      "action": "THROW",
      "path": "inProgressIssuesRedesignTemp"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "todoIssuesRedesignTemp",
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "statusCategories": [
                "TODO"
              ]
            }
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "todoIssuesRedesignTemp.totalCount"
          }
        ],
        "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
      },
      "action": "THROW",
      "path": "todoIssuesRedesignTemp"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "1894f7adb956d41d80dd7d309152870c";

export default node;
